// Estado de cada regla del panel de composición (tablero del delegado):
// "ok" cumple, "bad" no cumple, "pending" aún no aplica.

// Máximo: no cumple si se pasa.
export const maxStatus = (value, max) => (value > max ? "bad" : "ok");

// Mínimo: no cumple solo cuando el campo ya llega al umbral `from` en el que se exige.
export const minStatus = (value, min, inFieldCount, from) =>
  value >= min ? "ok" : inFieldCount >= from ? "bad" : "pending";
